// Super Admin (1), Faculty Role (3), HOD (4), Principal (16), Faculty Co-ordinator (18), Common HOD (23)
export const DAILY_PLANNER_ADD_STUDENT_ROLE_IDS = [1, 3, 4, 16, 18, 23];

// Faculty Role (3), HOD (4), Principal (16), Faculty Co-ordinator (18), Common HOD (23)
export const DAILY_PLANNER_ACADEMIC_FACULTY_ROLE_IDS = [3, 4, 16, 18, 23];

// Super Admin (1), HOD (4), Principal (16)
export const DAILY_PLANNER_APPROVER_ROLE_IDS = [1, 4, 16];

const ACADEMIC_FACULTY_ROLE_NAMES = [
  "faculty role",
  "faculty",
  "faculty co-ordinator",
  "faculty coordinator",
  "hod",
  "common hod",
  "principal",
];

const ADD_STUDENT_ROLE_NAMES = [
  "super admin",
  "admin",
  "faculty role",
  "hod",
  "principal",
  "faculty co-ordinator",
  "faculty coordinator",
  "common hod",
];

const APPROVER_ROLE_NAMES = [
  "super admin",
  "admin",
  "hod",
  "principal",
];

function getSessionUser(user) {
  if (user) return user;

  try {
    return JSON.parse(sessionStorage.getItem("AcharyaErpUser"));
  } catch {
    return null;
  }
}

function matchesRole(sessionUser, roleIds, roleNames) {
  if (!sessionUser) return false;

  const roleId = Number(sessionUser.roleId);
  if (roleIds.includes(roleId)) return true;

  const roleName = String(sessionUser.roleName || "")
    .toLowerCase()
    .trim();
  return roleNames.includes(roleName);
}

export function canAddDailyPlannerStudent(user) {
  return matchesRole(
    getSessionUser(user),
    DAILY_PLANNER_ADD_STUDENT_ROLE_IDS,
    ADD_STUDENT_ROLE_NAMES
  );
}

export function isDailyPlannerAcademicFaculty(user) {
  return matchesRole(
    getSessionUser(user),
    DAILY_PLANNER_ACADEMIC_FACULTY_ROLE_IDS,
    ACADEMIC_FACULTY_ROLE_NAMES
  );
}

export function isDailyPlannerCommonHod(user) {
  return matchesRole(getSessionUser(user), [23], ["common hod"]);
}

export function canApproveDailyPlanner(user) {
  return matchesRole(
    getSessionUser(user),
    DAILY_PLANNER_APPROVER_ROLE_IDS,
    APPROVER_ROLE_NAMES
  );
}

export function isDailyPlannerAdmin(user) {
  return matchesRole(getSessionUser(user), [1], ["super admin", "admin"]);
}
